import React from "react";
import Template from "../../../../templates/Crew/Departure/ServerUpdate/ServerUpdateDepartureComplete";
import Default from "../../../../layouts/DefaultCrew";

const ServerUpdateDepartureComplete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Departure"}>
      <Template />
    </Default>
  );
};

export default ServerUpdateDepartureComplete;
